import { isRemote } from '../env';
import { LocalHumanResourcesRepository } from './localRepository';
import { RemoteHumanResourcesRepository } from './remoteRepository';
import { IHumanResourcesRepository } from './IHumanResourcesRepository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: IHumanResourcesRepository | null = null;

export function getHumanResourcesRepository(getToken?: () => Promise<string | null>): IHumanResourcesRepository {
  if (!instance) {
    instance = isRemote ? new RemoteHumanResourcesRepository(getToken ?? getAuthToken) : new LocalHumanResourcesRepository();
  }
  return instance;
}
